(function() {
'use strict';

function initMenuDrawerToggle() {
const menuDrawerContainer = document.getElementById('Details-menu-drawer-container');

// Query all possible announcement bar selectors
const announcementBars = document.querySelectorAll(
    '.countdown--mobile-visible, .vertical-announcement-section, .announcement-bar--target'
);

const hamburgerButton = menuDrawerContainer?.querySelector('summary');


if (!menuDrawerContainer || announcementBars.length === 0 || !hamburgerButton) {
    
    return;
}


// Intercept click BEFORE details opens
hamburgerButton.addEventListener('click', function(e) {
    const isCurrentlyOpen = menuDrawerContainer.hasAttribute('open');
    
    
    if (isCurrentlyOpen) {
    // Will close - show all announcements
    announcementBars.forEach(bar => {
        bar.style.display = '';
    });
    } else {
    // Will open - hide all announcements
    announcementBars.forEach(bar => {
        bar.style.display = 'none';
    });
    }
}, true);

// Backup: Monitor attribute changes
const observer = new MutationObserver(function(mutations) {
    const isOpen = menuDrawerContainer.hasAttribute('open');
    announcementBars.forEach(bar => {
    bar.style.display = isOpen ? 'none' : '';
    });
});

observer.observe(menuDrawerContainer, {
    attributes: true,
    attributeFilter: ['open']
});
}

// Wait for DOM to be ready
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initMenuDrawerToggle);
} else {
initMenuDrawerToggle();
}

})();